export default __webpack_public_path__ + "static/media/1833.61c6c01f.png";